module.exports = __webpack_public_path__ + "img/DUPLIO3.76cf663d.png";